<template>
  <div class="auth-container">
    <h1>Évaluation de Niveau en Haltérophilie</h1>
    <div v-if="!isAuthenticated">
      <p>Connectez-vous pour évaluer votre niveau d'haltérophilie</p>
      <button @click="login" class="login-button">
        <img
          src="https://developers.google.com/identity/images/g-logo.png"
          alt="Google logo"
        />
        Se connecter avec Google
      </button>
    </div>
    <div v-else>
      <p>Bienvenue, {{ user.displayName }} !</p>
      <button @click="goToPerformance" class="nav-button">
        Évaluer mon niveau
      </button>
      <button @click="logout" class="logout-button">Déconnexion</button>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { loginWithGoogle, logout } from "../services/auth";

export default {
  name: "AuthComponent",
  setup() {
    const store = useStore();
    const router = useRouter();

    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    const user = computed(() => store.getters.currentUser);

    const login = async () => {
      try {
        const user = await loginWithGoogle();
        store.dispatch("loginUser", user);
      } catch (error) {
        console.error("Erreur lors de la connexion:", error);
        // Gérer l'erreur (afficher un message à l'utilisateur)
      }
    };

    const handleLogout = async () => {
      try {
        await logout();
        store.dispatch("logoutUser");
      } catch (error) {
        console.error("Erreur lors de la déconnexion:", error);
        // Gérer l'erreur
      }
    };

    const goToPerformance = () => {
      router.push("/performance");
    };

    return {
      isAuthenticated,
      user,
      login,
      logout: handleLogout,
      goToPerformance,
    };
  },
};
</script>

<style scoped>
.auth-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

h1 {
  color: #333;
  margin-bottom: 30px;
}

.login-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover {
  background-color: #f5f5f5;
}

.login-button img {
  width: 20px;
  margin-right: 10px;
}

.nav-button,
.logout-button {
  margin: 10px;
  padding: 10px 20px;
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.nav-button:hover {
  background-color: #3367d6;
}

.logout-button {
  background-color: #f44336;
}

.logout-button:hover {
  background-color: #d32f2f;
}
</style>
